import { getDataAPI } from "../../utils/fetchData"


export const TYPES = {
  CONTENT_REQUEST_LOADING: "CONTENT_REQUEST_LOADING",
  CONTENT_REQUEST_SUCCESS: "CONTENT_REQUEST_SUCCESS",
  CONTENT_REQUEST_ERROR: "CONTENT_REQUEST_ERROR",
  CONTENT_EXIT: "CONTENT_EXIT",
};


export const getOne = (key) => async (dispatch) => {
  try {
    dispatch({
      type: TYPES.CONTENT_REQUEST_LOADING,
    });

    const res = await getDataAPI(`contents/one/${key}`);
    if (res) {
      dispatch({
        type: TYPES.CONTENT_REQUEST_SUCCESS,
        payload: { data: res.data?.data },
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.CONTENT_REQUEST_ERROR,
      payload: error.response?.message || error.response?.data?.msg,
    });
  }
};